import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../services/adminApi";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await authApi.login(email, password);
      if (data?.user?.role !== "admin") {
        setError("This account is not an admin.");
        await authApi.logout();
        return;
      }
      navigate("/overview");
    } catch (err) {
      setError(err?.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card card">
        <div className="auth-brand">
          <img src="/logo-icon.png" alt="" width={44} height={44} />
        </div>
        <h2 style={{ marginBottom: 6 }}>Admin Login</h2>
        <p className="muted" style={{ marginTop: 0 }}>
          Use an account with role admin.
        </p>
        <form onSubmit={submit}>
          <div style={{ marginBottom: 10 }}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%" }}
              required
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%" }}
              required
            />
          </div>
          {error ? (
            <div className="error" style={{ marginBottom: 10 }}>
              {error}
            </div>
          ) : null}
          <button className="btn-primary" disabled={loading} style={{ width: "100%" }}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <p className="muted" style={{ marginTop: 14, fontSize: 12 }}>
          Aiarbix Admin Panel
        </p>
        <p className="muted" style={{ marginTop: 2, fontSize: 12 }}>
          Secure monitoring and operations
        </p>
        <div style={{ marginTop: 10 }}>
          <span className="pill ok">Protected Area</span>
        </div>
      </div>
    </div>
  );
}
